import { InjectionToken } from '@angular/core';

/** Per-portal configuration for the shared MixpanelService. */
export interface MixpanelAnalyticsConfig {
  isActive: boolean;
  token: string;
  /** Ingestion host; defaults to the EU host. Override for a US-resident project. */
  apiHost?: string;
  defaultLocale?: string;
  getLocale?: () => string | undefined | null;
  excludedEvents?: string[];
}

export const MIXPANEL_ANALYTICS_CONFIG =
  new InjectionToken<MixpanelAnalyticsConfig>('MIXPANEL_ANALYTICS_CONFIG');

export const DEFAULT_MIXPANEL_API_HOST = 'https://api-eu.mixpanel.com';
